// extracted by mini-css-extract-plugin
export default {"root":"tweet-body_root__QhP+Y"};